export enum PlayerKind {
  HUMAN = 'HUMAN',
  BOT = 'BOT'
}

export enum PlayKind {
  observe = 'observe',
  play = 'play'
}
